import { render, staticRenderFns } from "./AdminEmailLogDetail.vue?vue&type=template&id=17f70bb8&"
import script from "./AdminEmailLogDetail.vue?vue&type=script&lang=js&"
export * from "./AdminEmailLogDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports